<template>
  <div class="help-center">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <div class="logo">
        <i class="fas fa-question-circle"></i>
        <h1>{{ $t('_bzzx._bzzx') }}</h1>
      </div>
      <ul class="nav-menu">
        <li
          v-for="(item, index) in navItems"
          :key="index"
          :class="['nav-item', { active: activeNav === index }]"
          @click="activeNav = index"
        >
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>

    <!-- 右侧内容 -->
    <div class="content">
      <div class="content-header">
        <h2>{{ activeNavItem.title }}</h2>
        <p>{{ activeNavItem.description }}</p>
      </div>

      <div class="faq-section" v-for="(section, index) in activeNavItem.sections" :key="index">
        <h3 class="section-title">
          <i :class="section.icon"></i>
          {{ section.title }}
        </h3>
        <ul class="faq-list">
          <li
            v-for="(faq, faqIndex) in section.faqs"
            :key="faqIndex"
            :class="['faq-item', { active: faq.active }]"
            @click="toggleFaq(faq)"
          >
            <div class="faq-question">
              <span>{{ faq.question }}</span>
              <i class="fas fa-chevron-down"></i>
            </div>
            <div class="faq-answer">
              <p>{{ faq.answer }}</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="contact-section">
        <h3 class="contact-title">{{ $t('_bzzx._myzdwt') }}</h3>
        <p class="contact-desc">{{ $t('_bzzx._khjybbzn') }}</p>
        <a href="#" class="contact-btn">
          <i class="fas fa-headset"></i> {{ $t('_bzzx._lxkf') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpCenter',
  data() {
    return {
      activeNav: 0,
      searchQuery: '',
      navItems: [
        {
          title: this.$t('_bzzx._rhzczh'),
          description: '',
          icon: 'fas fa-user-plus',
          sections: [
            {
              title: '',
              icon: 'fas fa-list-ol',
              faqs: [
                {
                  question: this.$t('_bzzx._rhzcxyh'),
                  answer: this.$t('_bzzx._rhzcxyh1'),
                  active: true
                }
              ]
            }
          ]
        },
        {
          title: this.$t('_bzzx._rhcz'),
          description: '',
          icon: 'fas fa-envelope',
          sections: [
            {
              title: '',
              icon: 'fas fa-envelope-open-text',
              faqs: [
                {
                  question: this.$t('_bzzx._rhcz2'),
                  answer: this.$t('_bzzx._rhcz3'),
                  active: true
                }
              ]
            }
          ]
        },
        {
          title: this.$t('_bzzx._rhjsdj'),
          description: '',
          icon: 'fas fa-crown',
          sections: [
            {
              title: '',
              icon: 'fas fa-gem',
              faqs: [
                {
                  question: this.$t('_bzzx._rhjsdj'),
                  answer: this.$t('_bzzx._rhjsdj2'),
                  active: true
                }
              ]
            }
          ]
        },
        {
          title: this.$t('_bzzx._rhtx'),
          description: '',
          icon: 'fas fa-coins',
          sections: [
            {
              title: '',
              icon: 'fas fa-wallet',
              faqs: [
                {
                  question: this.$t('_bzzx._rhtx'),
                  answer: this.$t('_bzzx._rhtx1'),
                  active: true
                }
              ]
            }
          ]
        },
        {
          title: this.$t('_bzzx._qtwt'),
          description: '',
          icon: 'fas fa-ellipsis-h',
          sections: [
            {
              title: '',
              icon: 'fas fa-question',
              faqs: [
                {
                  question: this.$t('_bzzx._qtwt1'),
                  answer: this.$t('_bz._lxkf'),
                  active: true
                }
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    activeNavItem() {
      return this.navItems[this.activeNav]
    }
  },
  methods: {
    toggleFaq(faq) {
      faq.active = !faq.active
    }
  }
}
</script>

<style scoped>
/* ============================================================
   帮助中心 - 暗色主题
   ============================================================ */

.help-center {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  background: #0f1419;
  border-radius: 16px;
  border: 1px solid #1a1f26;
  overflow: hidden;
  min-height: 600px;
}

/* ============================================================
   侧边栏
   ============================================================ */
.sidebar {
  width: 260px;
  background: #0a0d0f;
  padding: 24px 0;
  flex-shrink: 0;
  border-right: 1px solid #1a1f26;
}

.logo {
  display: flex;
  align-items: center;
  padding: 0 24px 20px;
  border-bottom: 1px solid #1a1f26;
  margin-bottom: 16px;
}

.logo i {
  font-size: 24px;
  color: #e50914;
  margin-right: 10px;
}

.logo h1 {
  font-size: 20px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0;
}

.nav-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  color: #8a949f;
  border-left: 3px solid transparent;
  font-size: 14px;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.03);
  color: #e8edf2;
}

.nav-item.active {
  background: rgba(229, 9, 20, 0.08);
  color: #e50914;
  border-left-color: #e50914;
}

.nav-item i {
  width: 22px;
  margin-right: 12px;
  font-size: 15px;
}

/* ============================================================
   内容区
   ============================================================ */
.content {
  flex: 1;
  padding: 32px 36px 36px;
  min-width: 0;
}

.content-header {
  margin-bottom: 28px;
}

.content-header h2 {
  font-size: 24px;
  color: #e8edf2;
  margin: 0 0 6px;
  font-weight: 600;
}

.content-header p {
  color: #5a6672;
  font-size: 14px;
  margin: 0;
}

/* ============================================================
   FAQ 分区
   ============================================================ */
.faq-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 16px;
  color: #e8edf2;
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.section-title i {
  color: #e50914;
}

.faq-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.faq-item {
  background: #0a0d0f;
  border-radius: 10px;
  margin-bottom: 8px;
  overflow: hidden;
  border: 1px solid #141a20;
  transition: all 0.25s;
}

.faq-item:hover {
  border-color: #1a1f26;
}

.faq-question {
  padding: 14px 18px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #b0bcc8;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
}

.faq-question:hover {
  color: #e8edf2;
}

.faq-question i {
  transition: transform 0.3s;
  color: #5a6672;
  font-size: 13px;
  flex-shrink: 0;
  margin-left: 12px;
}

.faq-answer {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease, padding 0.35s ease;
  color: #8a949f;
  font-size: 14px;
  line-height: 1.7;
}

.faq-answer p {
  margin: 0;
}

.faq-item.active .faq-answer {
  padding: 0 18px 16px;
  max-height: 500px;
}

.faq-item.active .faq-question i {
  transform: rotate(180deg);
}

.faq-item.active {
  border-color: #1a1f26;
  background: #0f1419;
}

.faq-item.active .faq-question {
  color: #e8edf2;
}

/* ============================================================
   联系客服
   ============================================================ */
.contact-section {
  background: #0a0d0f;
  border-radius: 12px;
  padding: 24px 28px;
  margin-top: 32px;
  border: 1px solid #141a20;
}

.contact-title {
  font-size: 17px;
  color: #e8edf2;
  margin: 0 0 6px;
  font-weight: 600;
}

.contact-desc {
  color: #5a6672;
  font-size: 14px;
  margin: 0 0 16px;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #fff;
  padding: 10px 24px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(229, 9, 20, 0.3);
}

.contact-btn i {
  font-size: 15px;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 820px) {
  .help-center {
    flex-direction: column;
    border-radius: 12px;
  }

  .sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #1a1f26;
    padding: 16px 0;
  }

  .logo {
    padding: 0 20px 14px;
  }

  .logo h1 {
    font-size: 18px;
  }

  .nav-menu {
    display: flex;
    overflow-x: auto;
    padding: 0 16px;
    gap: 4px;
    flex-wrap: nowrap;
  }

  .nav-menu::-webkit-scrollbar {
    height: 2px;
  }

  .nav-menu::-webkit-scrollbar-thumb {
    background: #2a3138;
    border-radius: 4px;
  }

  .nav-item {
    padding: 8px 16px;
    border-left: none;
    border-bottom: 3px solid transparent;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .nav-item.active {
    border-left: none;
    border-bottom-color: #e50914;
  }

  .content {
    padding: 20px 20px 24px;
  }

  .content-header h2 {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .help-center {
    border-radius: 10px;
  }

  .content {
    padding: 16px 16px 20px;
  }

  .content-header h2 {
    font-size: 18px;
  }

  .content-header p {
    font-size: 13px;
  }

  .faq-question {
    padding: 12px 14px;
    font-size: 13px;
  }

  .faq-answer {
    font-size: 13px;
  }

  .faq-item.active .faq-answer {
    padding: 0 14px 14px;
  }

  .contact-section {
    padding: 18px 18px 20px;
  }

  .contact-title {
    font-size: 15px;
  }

  .contact-desc {
    font-size: 13px;
  }

  .contact-btn {
    padding: 8px 18px;
    font-size: 13px;
  }

  .nav-item {
    padding: 6px 12px;
    font-size: 12px;
  }

  .nav-item i {
    margin-right: 6px;
    font-size: 13px;
  }

  .section-title {
    font-size: 14px;
  }
}
</style>